export const CardStat = ({ value, title, className="" }) => (
    <div className={`bg-bgGraya border-containera rounded-2xl min-w-[140px] flex flex-col gap-2 items-start ${className}`}>
      <span className="text-7xl font-bold">{value}</span>
      <span className="text-xs text-gray-500 mb-1">{title}</span>
  </div>
);